import styled from "styled-components";
import { Link } from "react-router-dom";

// Title
export const TitlePage = styled.h2`
margin-bottom:.4em;
font-weight:800;
`;

// Links

export const NavLink = styled(Link)`
margin-right:1em;
padding: .4em .6em;
`;

// PostsContainer
export const SSContainer = styled.div`
display:flex;
flex-direction: column;
align-items:center;
justify-content:center;
`;

